import React, { useState } from "react"
import PropTypes from "prop-types"

const AccordionItem = ({ title, description, cite }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={`border rounded my-2 transition-all border-gray-300 ${
        isOpen ? "bg-blue-200" : "hover:bg-blue-50"
      }`}
    >
      <button
        className="w-full py-2 px-3 text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex justify-between">
          <h3 className={`font-semibold text-xl ${isOpen && "text-blue-500"}`}>
            {title}
          </h3>
          {isOpen ? <span>&#9650;</span> : <span>&#9660;</span>}
        </div>
      </button>
      {isOpen && (
        <div className="px-3 py-2">
          <p>{description}</p>
          {cite.map((item, index) => {
            return (
              <p className="italic text-sm text-gray-500" key={index}>
                Cite:{" "}
                <a href={item.href} target="_blank" rel="noopener noreferrer">
                  {item.title}
                </a>
                , {item.source}
              </p>
            )
          })}
        </div>
      )}
    </div>
  )
}

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cite: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      source: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
}

AccordionItem.defaultProps = {
  cite: [],
}

const InformativeAccordion = ({ items }) => (
  <div>
    {items.map((point, index) => (
      <AccordionItem key={index} {...point} />
    ))}
  </div>
)

InformativeAccordion.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default InformativeAccordion
